import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wdpbx8b4ft: FaireBrandEntity = {
  token: "b_wdpbx8b4ft",
  type: "brand",
  name: "EXPRESS RETAIL SOLUTIONS INC.",
  avatarUrl:
    "https://cdn.faire.com/fastly/824f63ce54369fa1845da0edecb1b715958dafc864e964570624ba65371f48ea.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d916ffd92ec636f19016b422ff0091cceea9f42244110466dd174e6e7493a618.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/824f63ce54369fa1845da0edecb1b715958dafc864e964570624ba65371f48ea.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d916ffd92ec636f19016b422ff0091cceea9f42244110466dd174e6e7493a618.webp",
  location: "11722, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "MERCHANDISING MEETS ANALYTICS\nDATA-POWERED RETAIL SOLUTIONS THAT DRIVES RESULTS\n\nOur mission is to deliver exceptional value to our retail and wholesale partners. Through collaborative efforts and superior execution, we enhance competitiveness, sales, and profits by leveraging data-driven analytics in the market. We are committed to providing expert retail assistance and innovative solutions that consistently surpass expectations.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:20.003Z",
    importedBy: "entity-db-cli",
  },
};
